/*@flow*/
import { isXSmallScreen } from 'lib/getScreenWidth';
export default isXSmallScreen;
